import { UUID } from "crypto";

export const flowKeys = {
  all: ["flows"] as const,
  lists: () => [...flowKeys.all, "list"] as const,
  list: (filters?: any) => [...flowKeys.lists(), { filters }] as const,
  paginated: (filters?: any, page?: number, size?: number) =>
    [...flowKeys.lists(), "paginated", { filters, page, size }] as const,
  details: () => [...flowKeys.all, "detail"] as const,
  detail: (id: UUID) => [...flowKeys.details(), id] as const,
  byOrder: (orderId: UUID) => [...flowKeys.all, "byOrder", orderId] as const,
  byProduct: (productId: UUID) =>
    [...flowKeys.all, "byProduct", productId] as const,
  byTransaction: (transactionId: UUID) =>
    [...flowKeys.all, "byTransaction", transactionId] as const,
  traceability: (flowId: UUID) =>
    [...flowKeys.all, "traceability", flowId] as const,
  metadataKeys: () => [...flowKeys.all, "metadataKeys"] as const,
} as const;
